export interface PageErrorEditAccessInput {
  embedded: boolean;
  fromAllowedEntry: boolean;
}

export const PAGE_ERROR_EDIT_HISTORY_STATE_KEY = 'pageErrorEdit';
export const PAGE_ERROR_EDIT_WINDOW_NAME_PREFIX = 'picture-book-page-error-edit:';

export const createPageErrorEditWindowName = (): string =>
  `${PAGE_ERROR_EDIT_WINDOW_NAME_PREFIX}${Date.now().toString(36)}-${Math.random()
    .toString(36)
    .slice(2)}`;

export const isPageErrorEditHistoryState = (value: unknown): boolean => value === true;

export const isPageErrorEditWindowName = (value: unknown): boolean =>
  typeof value === 'string' && value.startsWith(PAGE_ERROR_EDIT_WINDOW_NAME_PREFIX);

export const canShowPageErrorEdit = ({ embedded, fromAllowedEntry }: PageErrorEditAccessInput): boolean => {
  if (embedded) return true;
  return fromAllowedEntry;
};
